// subworkPath.js — caminho do worktree isolado de subagente (BUG-O).
// Antes o sufixo era hash de `task.length` → QUALQUER par de tasks do mesmo
// tamanho colidia no MESMO /tmp/apolo-subwork-… e worktrees paralelos se
// clobberavam. Agora é FNV-1a do CONTEÚDO → tasks distintas ⇒ paths distintos.

/** FNV-1a 32-bit do conteúdo — determinístico, sem deps, roda em browser+node. */
function fnv1a(str) {
  let h = 0x811c9dc5;
  for (let i = 0; i < str.length; i += 1) {
    h ^= str.charCodeAt(i);
    h = Math.imul(h, 0x01000193);
  }
  return (h >>> 0).toString(36);
}

/** Caminho estável e content-addressed do worktree descartável do subagente. */
export function subworkPath(task, sessionId) {
  return `/tmp/apolo-subwork-${fnv1a(String(task || ''))}-${(sessionId || 'x').slice(0, 6)}`;
}
